import { createGlobalState } from 'react-use'

export const useCookiePopUpState = createGlobalState<boolean>(false)
